import { PlusOutlined } from '@ant-design/icons'
import { Button, Checkbox } from 'antd'

interface Props {
  onClick: (id: string) => void
  showArchived: boolean
  onShowArchivedChange: (checked: boolean) => void
}

export const HeaderList = ({ onClick, showArchived, onShowArchivedChange }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <Checkbox
          checked={showArchived}
          onChange={(e) => onShowArchivedChange(e.target.checked)}
        >
          Показать архивные
        </Checkbox>
        <Button type='primary' size='large' icon={<PlusOutlined />} onClick={() => onClick('create')}>
          Создать подборку
        </Button>
      </div>
    </div>
  )
}
